import classnames from 'classnames';
import _get from 'lodash/get';
import React, { useContext } from 'react';
import { Text } from 'wix-style-react';
import { TYPES } from '../../../utils/flattenTree/utils/consts';
import { getOperationMenuName } from '../../../utils';
import { ApiDisplay, API_TYPES } from '../ApiDisplay';
import { NAV_TYPES } from '../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { ActiveLink } from '../ActiveLink';
import { sectionPrefix } from '../NavigationMenu/utils';
import { CustomLink } from '../PageElements/CustomLink';
import { WebhookIcon, ClientEvent } from '../PageElements/svgs';
import { StoreContext } from '../../appContext/StoreProvider';
import style from './TreeMenuLink.scss';
import { TreeMenuLinkHttpMethod } from './TreeMenuLinkHttpMethod';
import { useExperiments } from '@wix/wix-experiments-react';

export const TreeMenuLink = ({
  prefix,
  item,
  treeDepth,
  type,
  JSLayoutType,
}) => {
  const { store } = useContext(StoreContext);

  const { experiments } = useExperiments({ suspense: false });
  const isClientEventsEnabled = experiments.enabled(
    'specs.wix-docs.ClientEvents',
  );

  const isRpcRest = store.viewer.viewerConfig.layoutType === API_TYPES.RPC_REST;

  const getUrl = () => {
    return `/${sectionPrefix(prefix, item.urlFormat)}`;
  };

  const isEventLink = () => type === TYPES.EVENT || type === TYPES.WEBHOOK;
  const isClientEventLink = () => type === TYPES.CLIENT_EVENT;

  const getDisplayName = () => {
    const name = item.displayName || item.name;
    if (type === TYPES.OPERATION || type === TYPES.CLIENT_EVENT) {
      return getOperationMenuName(
        name,
        store.viewer.viewerConfig.layoutType,
        JSLayoutType,
      );
    }
    return name;
  };

  const hasMethod = _get(item, 'docs.request', '') !== '' || isEventLink();
  return (
    <div
      id={`${prefix}.${item.urlFormat}`}
      key={`treeMenuItem_${prefix}#${item.name}`}
      className={classnames({
        [style.leftMenuLevel1]: true,
        [style.topLevel]: treeDepth === 1,
      })}
    >
      <ActiveLink>
        {({ isActive }) => (
          <CustomLink
            className={`${style.leftMenuAnchorLink} ${
              isActive(getUrl()) ? style.focusItem : ''
            }`}
            to={{
              pathname: getUrl(),
              state: { navType: NAV_TYPES.MENU_ARTICLE },
            }}
            data-hook={getUrl()}
          >
            {JSLayoutType ? (
              isClientEventLink() && (
                <ClientEvent size="20px" className={style.clientEventIcon} />
              )
            ) : (
              <ApiDisplay>
                <ApiDisplay.REST matchInitialType>
                  <TreeMenuLinkHttpMethod
                    method={_get(item, 'docs.request', '')}
                  />
                  {isEventLink() && (
                    <WebhookIcon
                      data-hook="webhook-icon"
                      size="20px"
                      className={style.webhookIcon}
                    />
                  )}
                </ApiDisplay.REST>
                {isClientEventsEnabled && (
                  <ApiDisplay.JS matchInitialType>
                    {isClientEventLink() && (
                      <ClientEvent
                        size="20px"
                        className={style.clientEventIcon}
                      />
                    )}
                  </ApiDisplay.JS>
                )}
              </ApiDisplay>
            )}

            <div
              className={classnames({
                [style.textContainer]: true,
                [style.fullWidth]: item.isMainObject || !hasMethod,
                [style.rpcRest]: isRpcRest,
                [style.isEvent]: isEventLink(),
              })}
            >
              <Text
                className={style.AnchorLinkDisplayName}
                size="small"
                weight="normal"
                secondary
                ellipsis
                placement="right"
              >
                {getDisplayName()}
              </Text>
            </div>
          </CustomLink>
        )}
      </ActiveLink>
    </div>
  );
};
